
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.543 16.503c-.066 0-.132-.001-.199-.004H16.5a.75.75 0 010-1.5h1.875l.15.003A3.225 3.225 0 0021.748 12a3.212 3.212 0 00-3.342-3.001L16.5 9a.75.75 0 010-1.5h1.875a4.705 4.705 0 014.874 4.46v.08a4.713 4.713 0 01-4.706 4.463zM5.443 16.503A4.705 4.705 0 01.751 12.04a.988.988 0 010-.077 4.71 4.71 0 014.907-4.462L7.5 7.5a.75.75 0 010 1.5H5.625a3.223 3.223 0 00-3.374 3 3.213 3.213 0 003.341 3h1.907a.75.75 0 010 1.5H5.625c-.05.002-.116.003-.182.003zM12 5.999a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v4.5a.75.75 0 01-.75.75zM9 5.999a.743.743 0 01-.53-.22l-1.5-1.5c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53c.141-.142.33-.22.53-.22s.389.078.53.22l1.5 1.5c.142.141.22.33.22.53s-.078.389-.22.53a.741.741 0 01-.53.22zM15 5.999a.743.743 0 01-.53-.22c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53l1.5-1.5a.744.744 0 011.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-1.5 1.5a.743.743 0 01-.53.22zM12 23.999a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v4.5a.75.75 0 01-.75.75zM7.5 20.999a.752.752 0 01-.53-1.281l1.5-1.5a.744.744 0 011.06 0 .752.752 0 010 1.061l-1.5 1.5a.741.741 0 01-.53.22zM16.5 20.999a.743.743 0 01-.53-.22l-1.5-1.5a.752.752 0 01.53-1.281c.2 0 .389.078.53.22l1.5 1.5a.752.752 0 01-.53 1.281z"}})])
          )
        }
      }
    